"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Question = void 0;

var Question =
/** @class */
function () {
  function Question() {}

  Question.prototype.AnswerBindingType = function () {
    return [{
      slug: 'equal_to',
      name: 'Equal To',
      description: null,
      isEqualTo: true,
      isNotEqualTo: false
    }, {
      slug: 'not_equal_to',
      name: 'Not Equal To',
      description: null,
      isEqualTo: false,
      isNotEqualTo: true
    }];
  };

  Question.prototype.QuestionContextType = function () {
    return [{
      slug: 'registration',
      name: 'Registration',
      description: null,
      isRegistration: true,
      isLeadCapture: false
    }, {
      slug: 'lead',
      name: 'Lead Capture',
      description: null,
      isRegistration: false,
      isLeadCapture: true
    }];
  };

  Question.prototype.QuestionType = function () {
    return [{
      slug: 'checkbox',
      name: 'Checkboxes',
      description: null,
      isCheckbox: true,
      isRadio: false,
      isMulti: false,
      isText: false,
      isSelect: false,
      isDate: false,
      isWaiver: false,
      isAddress: false
    }, {
      slug: 'radio',
      name: 'Radio Buttons',
      description: null,
      isCheckbox: false,
      isRadio: true,
      isMulti: false,
      isText: false,
      isSelect: false,
      isDate: false,
      isWaiver: false,
      isAddress: false
    }, {
      slug: 'multi',
      name: 'Paragraph',
      description: null,
      isCheckbox: false,
      isRadio: false,
      isMulti: true,
      isText: false,
      isSelect: false,
      isDate: false,
      isWaiver: false,
      isAddress: false
    }, {
      slug: 'text',
      name: 'Short Answer',
      description: null,
      isCheckbox: false,
      isRadio: false,
      isMulti: false,
      isText: true,
      isSelect: false,
      isDate: false,
      isWaiver: false,
      isAddress: false
    }, {
      slug: 'select',
      name: 'Dropdown Select',
      description: null,
      isCheckbox: false,
      isRadio: false,
      isMulti: false,
      isText: false,
      isSelect: true,
      isDate: false,
      isWaiver: false,
      isAddress: false
    }, {
      slug: 'date',
      name: 'Select Date',
      description: null,
      isCheckbox: false,
      isRadio: false,
      isMulti: false,
      isText: false,
      isSelect: false,
      isDate: true,
      isWaiver: false,
      isAddress: false
    }, {
      slug: 'waiver',
      name: 'Sign Waiver',
      description: null,
      isCheckbox: false,
      isRadio: false,
      isMulti: false,
      isText: false,
      isSelect: false,
      isDate: false,
      isWaiver: true,
      isAddress: false
    }, {
      slug: 'address',
      name: 'Address',
      description: null,
      isCheckbox: false,
      isRadio: false,
      isMulti: false,
      isText: false,
      isSelect: false,
      isDate: false,
      isWaiver: false,
      isAddress: true
    }];
  };

  return Question;
}();

exports.Question = Question;